/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationRequestEvaluation } from './taskEvaluationRequestEvaluation';
import type { TaskEvaluationRequestFeedback } from './taskEvaluationRequestFeedback';

/**
 * Request to evaluate a single task submission
 */
export interface TaskEvaluationRequest {
  evaluation?: TaskEvaluationRequestEvaluation;
  feedback?: TaskEvaluationRequestFeedback;
}
